import LegalDisclaimer from './LegalDisclaimer';
import TextStyling from './TextStyling';

const Cta = ({ text = '', stylings = [], id = '' } = {}) => ({
  text: String(text),
  stylings: stylings.map((styling) => String(styling)),
  id: String(id),
});

const ProductIntro = ({
  header = '',
  subheader = '',
  ctas = [],
  description = [],
  footer = '',
  legalDisclaimer = {},
} = {}) => ({
  header: String(header),
  subheader: String(subheader),
  ctas: ctas.map((cta) => Cta(cta)),
  description: description.map((item) => TextStyling(item)),
  footer: String(footer),
  legalDisclaimer: LegalDisclaimer(legalDisclaimer),
});

export default ProductIntro;
